.content {
    min-height: 49px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    word-break: break-word;
    padding: 4px 8px;
}
